export const FREE_MAIL_DOMAIN_LIST: string[] = [
  'gmail.com',
  'icloud.com',
  'qq.com',
  'outloock.com',
  'bjwgydx131.wecom.work',
  '163.com',
  'naver.com',
  'hotmail.com',
  '139.com',
  'daum.net',
  'hanmail.net',
  'mac.com',
  'yahoo.co.jp',
  'pnptc.com',
  'nifty.com',
] as const;
